import { useMemo } from 'react'

import { QueryHookOptions } from '@apollo/client'

import {
  IGetSitePermitAggregationListQuery,
  IGetSitePermitAggregationListQueryVariables,
  useGetSitePermitAggregationListQuery,
} from '~/client/graph/operations/generated/SitePermits.generated'
import Workflow from '~/client/src/shared/models/Workflow'

export default function useWorkflowsByIds(
  projectId: string,
  workflowIds: string[],
  withAllDrafts?: boolean,
  withDeleted?: boolean,
  options?: QueryHookOptions<
    IGetSitePermitAggregationListQuery,
    IGetSitePermitAggregationListQueryVariables
  >,
) {
  const { data: workflowData, loading: workflowLoading } =
    useGetSitePermitAggregationListQuery({
      variables: {
        filter: {
          projectId,
          ids: workflowIds,
          withAllDrafts,
          withDeleted,
        },
        limit: workflowIds.length,
        offset: 0,
      },
      skip: !projectId || !workflowIds.length,
      fetchPolicy: 'cache-and-network',
      ...(options || {}),
    })

  const workflows = useMemo(() => {
    const allowedIds = new Set(workflowIds)
    const list = workflowData?.sitePermitsAggregation?.data || []
    return list
      .map(workflow => Workflow.fromDto(workflow))
      .filter(workflow => allowedIds.has(workflow.id))
  }, [workflowData, workflowIds])

  return {
    workflows,
    workflowLoading,
  }
}
